import { formatDate } from "libs/utils/format";
import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class PersonalService {
  async getPersonalList({
    personalId: personalID,
    keyword: Keyword,
    agentId: agentID,
  }) {
    try {
      const params = qs.stringify({
        ...(personalID && { personalID }),
        ...(Keyword && { Keyword }),
        ...(agentID && { agentID }),
      });
      const response = await HttpClient.get(`/api/personal/list?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadPassport(file, personalID) {
    try {
      const formData = new FormData();
      formData.append("FileUpload", file);
      formData.append("personalID", personalID);

      const response = await HttpClient.post(
        "/api/personal/passport/upload",
        formData,
        true
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addPersonal(body) {
    try {
      const response = await HttpClient.post("/api/personal/add", {
        ...body,
        birthDate: !body.birthDate ? null : formatDate(body.birthDate),
        dateofIssue: !body.dateofIssue ? null : formatDate(body.dateofIssue),
        validuntil: !body.validuntil ? null : formatDate(body.validuntil),
      });

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addPassportPersonal(body) {
    try {
      const response = await HttpClient.post(
        "/api/personal/passport/add",
        body
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addPersonalReference(body) {
    try {
      const response = await HttpClient.post(
        "/api/personal/reference/add",
        body
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getPersonalReference(personalID) {
    try {
      const response = await HttpClient.get(
        `/api/personal/reference/list?personalID=${personalID}`
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async apporvePersonalReference(body) {
    try {
      const response = await HttpClient.post(
        `/api/personal/reference/changestatus`,
        body
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addPersonalSignature(body) {
    try {
      const response = await HttpClient.post(
        `/api/personal/signature/edit `,
        body
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new PersonalService();
